import './bottom-tab-bar.scss';

import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import MobileBurgerMenuIcon from '@/media/icons/mobile-burger-menu.svg?react';
import NavOverviewIcon from '@/media/icons/nav-overview.svg?react';
import NavRequestsIcon from '@/media/icons/nav-requests.svg?react';
import { LocalizedNavLink } from '@/shared/ui';
import { useAppSelector } from '@/store';

import { MOBILE_BOTTOM_NAV_IDS, NAV, NAV_ROUTES } from '../sidebar/constants';

const BOTTOM_TAB_ICONS = {
  overview: NavOverviewIcon,
  requests: NavRequestsIcon
} as const;

interface IProps {
  isMobileMenuOpen: boolean;
  onMobileMenuToggle: () => void;
}

const BottomTabBar: React.FC<IProps> = ({
  isMobileMenuOpen,
  onMobileMenuToggle
}) => {
  const { t } = useTranslation();
  const { isInWebView } = useAppSelector((state) => state.app);

  const tabItems = useMemo(
    () =>
      NAV.filter((navItem) =>
        MOBILE_BOTTOM_NAV_IDS.includes(navItem.id)
      ) as Array<(typeof NAV)[number] & { id: keyof typeof BOTTOM_TAB_ICONS }>,
    []
  );

  return (
    <nav
      className={classNames('bottom-tab-bar', {
        'bottom-tab-bar--in-webview': isInWebView
      })}
      aria-label={t('layout.nav.menu')}
    >
      <div className="bottom-tab-bar__wrapper">
        {tabItems.map((navItem) => {
          const TabIcon = BOTTOM_TAB_ICONS[navItem.id];

          return (
            <LocalizedNavLink
              key={navItem.id}
              to={NAV_ROUTES[navItem.id]}
              end={navItem.id === 'overview'}
              className={({ isActive }) =>
                classNames('bottom-tab-bar__item', {
                  'bottom-tab-bar__item--active': isActive
                })
              }
            >
              <TabIcon className="bottom-tab-bar__icon" aria-hidden />
              <span className="bottom-tab-bar__label">{t(navItem.label)}</span>
            </LocalizedNavLink>
          );
        })}

        <button
          type="button"
          className={classNames('bottom-tab-bar__item', {
            'bottom-tab-bar__item--active': isMobileMenuOpen
          })}
          aria-expanded={isMobileMenuOpen}
          aria-label={t('layout.nav.menu')}
          onClick={onMobileMenuToggle}
        >
          <MobileBurgerMenuIcon className="bottom-tab-bar__icon" aria-hidden />
          <span className="bottom-tab-bar__label">{t('layout.nav.menu')}</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomTabBar;
